<template>
  <!-- 
    hover 顯示文字的 component 
    把此元件包住你的目標物件，並傳入參數
    1. placement: popup 方框的起始位置可傳入
        top-start
        top (預設)
        top-end
        bottom-start
        bottom
        bottom-end
    2. text: hover 後 popup 的顯示字串
  -->
  <el-dropdown :placement="placement" size="mini">
    <slot class="el-dropdown-link"></slot>

    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item disabled>{{ text }}</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import { Dropdown } from "element-ui";

export default {
  name: "hover-text",
  components: {
    Dropdown,
  },
  props: {
    placement: {
      type: String,
      default: "top",
    },
    text: {
      type: String,
      default: " ",
    },
  },
};
</script>

<style scoped>
.el-dropdown-menu {
  padding: 0px;
}
</style>